'use strict';

module.exports = require('./Autowhatever').default;